import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  HostListener,
  OnInit,
  ViewChild,
} from '@angular/core';

@Component({
  selector: 'app-carousel',
  templateUrl: './carousel.component.html',
  styleUrls: ['./carousel.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CarouselComponent implements AfterViewInit {
  @ViewChild('carouselItems', { static: true })
  carouselItems!: ElementRef<HTMLDivElement>;
  @ViewChild('btnLeft', { static: true })
  btnLeft!: ElementRef<HTMLAnchorElement>;
  @ViewChild('btnRight', { static: true })
  btnRight!: ElementRef<HTMLAnchorElement>;

  private activeDrag: boolean = false;
  private startX: number = 0;
  private scrollStart: number = 0;
  private scrollBy: number = 150;

  ngAfterViewInit(): void {
    this.iconVisibility();
    // Adding a scroll event listener to update the arrow visibility in real-time.
    this.carouselItems.nativeElement.addEventListener('scroll', () =>
      this.iconVisibility(),
    );
  }

  // Handles visibility of navigation buttons based on scroll position
  private iconVisibility(): void {
    const carouselItems = this.carouselItems.nativeElement;
    const scrollLeftValue = Math.ceil(carouselItems.scrollLeft);
    const scrollableWidth =
      carouselItems.scrollWidth - carouselItems.clientWidth;

    this.btnLeft.nativeElement.style.display =
      scrollLeftValue > 0 ? 'flex' : 'none';
    this.btnRight.nativeElement.style.display =
      scrollableWidth > scrollLeftValue ? 'flex' : 'none';
  }

  protected scrollLeft(): void {
    this.carouselItems.nativeElement.scrollLeft -= this.scrollBy;
  }

  protected scrollRight(): void {
    this.carouselItems.nativeElement.scrollLeft += this.scrollBy;
  }

  protected startDrag(event: MouseEvent): void {
    this.activeDrag = true;
    const carouselItems = this.carouselItems.nativeElement;
    this.startX = event.pageX - carouselItems.offsetLeft;
    this.scrollStart = carouselItems.scrollLeft;
    carouselItems.classList.add('dragging');
  }

  protected onDrag(event: MouseEvent): void {
    if (!this.activeDrag) return;

    const carouselItems = this.carouselItems.nativeElement;
    event.preventDefault(); // Prevent default dragging behavior
    const x = event.pageX - carouselItems.offsetLeft;
    const walk = (x - this.startX) * 2; // The `2` multiplier for faster scrolling
    carouselItems.scrollLeft = this.scrollStart - walk;

    this.iconVisibility();
  }

  protected stopDrag(): void {
    this.activeDrag = false;
    const carouselItems = this.carouselItems.nativeElement;
    carouselItems.classList.remove('dragging');
  }

  // Handle window resize to update icon visibility
  @HostListener('window:resize', ['$event'])
  onResize(): void {
    this.iconVisibility();
  }
}
